// TODO - We need this workaround for jsonapi-serializer, it should be resolved or investigated in FAAS-3714.

export {};

globalThis.global = globalThis;
